/* eslint-disable camelcase */
import { handleActions, createAction } from 'redux-actions';

export type PaymentStatus = 'completed' | 'failed'

export interface Transaction {
  invoice_number: string
  transaction_id: string
  tier_name: string
  billing_date: string
  status: PaymentStatus
}

export type TransactionsResponse = Array<Transaction>

export interface BillingState {
  isLoading: boolean
  failed: boolean
  details: null | TransactionsResponse
}

const initialState: BillingState = {
  isLoading: true,
  failed: false,
  details: null,
};

export const getTransactionsInitialized = createAction(
  '@platform/query/billing/transactions/get/init',
);
export const getTransactionsSucceeded = createAction(
  '@platform/query/billing/transactions/get/success',
  (payload: TransactionsResponse) => payload,
);
export const getTransactionsFailed = createAction(
  '@platform/query/billing/transactions/get/failed',
);

export default handleActions<BillingState, TransactionsResponse>({
  [getTransactionsInitialized.toString()]: () => initialState,
  [getTransactionsSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    failed: false,
    details: payload,
  }),
  [getTransactionsFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
  }),
}, initialState);
